// extracted by mini-css-extract-plugin
export default {"AttributeColumn":"AttributeColumn_AttributeColumn__uHQqu"};